import JobSearchPage from './JobSearchPage';

export default JobSearchPage;